(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var HINT_DELAY = 600;
  var MOBILE_BREAKPOINT = 1000;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function updateBar(slider, index) {
    var segs = slider.parentElement.querySelectorAll(".slider-seg");
    segs.forEach(function (seg, i) {
      seg.classList.toggle("is-active", i === index);
    });
  }

  function runHint(slider) {
    var w = slider.offsetWidth;
    if (!w) return;
    slider.scrollTo({ left: Math.round(w * 0.5), behavior: "smooth" });
    setTimeout(function () {
      slider.scrollTo({ left: 0, behavior: "smooth" });
    }, 500);
  }

  function initSliders(root) {
    var sliders = root.querySelectorAll("[data-slider]");
    sliders.forEach(function (slider, sliderIndex) {
      var slides = slider.querySelectorAll(".image-slide");

      if ("IntersectionObserver" in window && slides.length > 0) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                var index = Array.from(slides).indexOf(entry.target);
                if (index !== -1) updateBar(slider, index);
              }
            });
          },
          { root: slider, threshold: 0.5 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      if (slides.length > 1) {
        var item = slider.closest(".collection-grid-item");
        if (item) {
          item.addEventListener("mouseenter", function () {
            if (window.innerWidth >= MOBILE_BREAKPOINT) {
              item.classList.add("is-hovered");
            }
          });
          item.addEventListener("mouseleave", function () {
            item.classList.remove("is-hovered");
          });
        }
      }

      if (sliderIndex === 0 && slides.length > 1 && isMobile()) {
        setTimeout(function () {
          runHint(slider);
        }, HINT_DELAY);
      }
    });
  }

  function initLoadMore() {
    var btn = document.querySelector("[data-load-more]");
    if (!btn) return;

    var grid = document.querySelector("[data-collection-grid]");
    var wrap = document.querySelector("[data-load-more-wrap]");

    btn.addEventListener("click", function () {
      var nextUrl = btn.getAttribute("data-next-url");
      if (!nextUrl || btn.getAttribute("aria-busy") === "true") return;

      btn.setAttribute("aria-busy", "true");

      fetch(nextUrl)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newItems = doc.querySelectorAll("[data-collection-grid] > *");
          newItems.forEach(function (item) {
            grid.appendChild(item);
          });

          initSliders(grid);

          var nextBtn = doc.querySelector("[data-load-more]");
          if (nextBtn) {
            btn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            btn.removeAttribute("aria-busy");
          } else {
            wrap.remove();
          }
        })
        .catch(function () {
          btn.removeAttribute("aria-busy");
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initSliders(document);
      initLoadMore();
    });
  } else {
    initSliders(document);
    initLoadMore();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
